import { Theme } from "../types/theme";

export enum DsPromoBannerNewType {
    Link = "Link",
    QuickLotteriesStream = "QuickLotteriesStream",
}

export const enum DsPromoBannerNewHeaderType {
    Text = "Text",
    Lottery = "Lottery",
    LotteryIconCustomText = "LotteryIconCustomText",
    None = "None",
}

export const enum DsPromoBannerNewPlacement {
    CategoryPage = "categoryPage",
    QuickLotteryPage = "quickLotteryPage",
    GoldenWheel = "goldenWheel",
    BonusGoldenWheel = "bonusGoldenWheel",
}

export enum DsPromoBannerNewLinkType {
    Url = "Url",
    Casino = "Casino",
    Video = "Video",
    AppDownload = "AppDownload",
}

export interface AppLinks {
    androidUrl: string;
    iosUrl: string;
}

export interface DsPromoBannerNewDto {
    codeName: string;
    type: DsPromoBannerNewType;
    linkType: DsPromoBannerNewLinkType;
    urlLink: string;
    mobileAppEvent?: string;
    mobileAppArgument?: string;
    openInNewTab: boolean;
    dsTheme: Theme;
    gradient: boolean;
    headline: string;
    text: string;
    buttonText: string;
    headerType: DsPromoBannerNewHeaderType;
    headerIcon: string;
    headerText: string;
    lottery: string;
    lotteryDisplayName?: string;
    lotteryHeaderImage?: string;
    image: string;
    backgroundImage: string;
    linkGameExternalId?: string;
    appLinks?: AppLinks;
}
